import { Box, Typography } from "@mui/material";
import { CompanyType, PointsActionIncentivesProgramAward } from "@t3/shared";
import { BaseTransactionCard } from "./BaseTransactionCard";
import { CenteredContent, DateAndPointsRow } from "./TransactionCardComponents";

interface IncentivesProgramCardProps {
  action: PointsActionIncentivesProgramAward;
  company: CompanyType | null;
  createdAt: string;
}

export const IncentivesProgramCard = ({
  action,
  company,
  createdAt,
}: IncentivesProgramCardProps) => {
  const typeMeta = action.typeMeta;
  const pointSource = typeMeta.pointSource;

  const pointSourceData =
    pointSource && company?.pointSources?.[pointSource]
      ? company.pointSources[pointSource]
      : null;

  const logoUrl = pointSourceData?.logo;
  const pointSourceName = pointSourceData?.name || pointSource || "Program";
  // Fallback for old data that might not have points
  const pointsDisplay = typeMeta.points ?? "—";

  return (
    <BaseTransactionCard>
      <Box>
        {/* Centered Program Logo/Name */}
        <CenteredContent>
          {logoUrl ? (
            <Box
              component="img"
              src={logoUrl}
              alt={pointSourceName}
              sx={{
                maxWidth: "80%",
                maxHeight: 80,
                objectFit: "contain",
              }}
            />
          ) : (
            <Box
              sx={{
                px: 3,
                py: 2,
                bgcolor: "#f5f5f5",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#616161",
                  fontWeight: 600,
                }}
              >
                {pointSourceName}
              </Typography>
            </Box>
          )}
        </CenteredContent>

        {/* Date and Points Row */}
        <DateAndPointsRow
          date={createdAt}
          points={pointsDisplay}
          label="Reward"
          variant="rewarded"
        />
      </Box>
    </BaseTransactionCard>
  );
};
